import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle, ArrowRight, HeartHandshake } from 'lucide-react';
import { Button } from '../components/ui/button';

const ApplicationSuccess = () => {
  return (
    <div className="min-h-screen hero-pattern flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="card p-12 max-w-lg text-center"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="w-20 h-20 bg-[var(--success)]/10 rounded-full flex items-center justify-center mx-auto mb-6"
        >
          <CheckCircle className="w-10 h-10 text-[var(--success)]" />
        </motion.div>
        
        <h1 className="text-3xl font-bold font-['Cormorant_Garamond'] mb-4">Application Submitted!</h1>
        
        <p className="text-[var(--text-secondary)] mb-8">
          Thank you for applying to join the NC Help Hub team! We've received your application 
          and will review it shortly. You'll receive an email notification once your application 
          has been reviewed.
        </p>

        <div className="bg-[var(--accent)] rounded-xl p-6 mb-8 text-left">
          <h3 className="font-semibold mb-3">What happens next?</h3>
          <ul className="space-y-2 text-sm text-[var(--text-secondary)]">
            <li className="flex items-start gap-2">
              <span className="w-5 h-5 bg-[var(--primary)] text-white rounded-full flex items-center justify-center text-xs flex-shrink-0 mt-0.5">1</span>
              Our team will review your application within 2-3 business days
            </li>
            <li className="flex items-start gap-2">
              <span className="w-5 h-5 bg-[var(--primary)] text-white rounded-full flex items-center justify-center text-xs flex-shrink-0 mt-0.5">2</span>
              We may contact you for additional information or an interview
            </li>
            <li className="flex items-start gap-2">
              <span className="w-5 h-5 bg-[var(--primary)] text-white rounded-full flex items-center justify-center text-xs flex-shrink-0 mt-0.5">3</span>
              Once approved, you'll receive login credentials to access the worker portal
            </li>
          </ul>
        </div>

        <Link to="/">
          <Button className="btn-primary">
            Return to Home
            <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
        </Link>
      </motion.div>
    </div>
  );
};

export default ApplicationSuccess;
